import { HeroSection } from 'src/homepage/components/HeroSection'

export const Homepage = (): React.ReactElement => {
  return <HeroSection />
}
